module.exports = __webpack_public_path__ + "media/cluckles_the_brave.a550c8c9.webm";